<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Account Info Update</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Account Info</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <form @submit.prevent="AccountInfoUpdate" method="POST" novalidate>
          <div class="row">

            <div class="col-md-12">

              <div class="card">
                <div class="card-header">
                  Personal Info
                </div>
                <div class="card-body">

                  <div class="col-md-8">
                    <div class="form-group">
                      <label for="firstName">First Name</label>
                      <input type="text" class="form-control" id="firstName" v-model="accountInfo.firstName"
                        placeholder="First Name">
                    </div>
                    <div class="form-group">
                      <label for="lastName">Last Name</label>
                      <input type="text" class="form-control" id="lastName" v-model="accountInfo.lastName"
                        placeholder="Last Name">
                    </div>

                    <div class="form-group">
                      <label for="customer_email">Email address</label>
                      <input type="text" class="form-control" id="customer_email" v-model="accountInfo.emailAddress"
                        placeholder="Email address">
                    </div>
                    <div class="form-group">
                      <label for="fullName">Phone number</label>
                      <input type="text" class="form-control" id="phoneNumber" v-model="accountInfo.phone"
                        placeholder="Phone number">
                    </div>

                    <div class="form-group">
                      <label for="streetAddress">Street Address</label>
                      <textarea rows="3" cols="12" type="text" class="form-control" id="streetAddress"
                        v-model="accountInfo.streetAddress" placeholder="Street Address" />
                    </div>

                    <!-- <div class="form-group">
                                            <label for="area">Area</label>
                                            <input type="text" class="form-control" id="area"
                                            v-model="accountInfo.area"
                                            placeholder="Area">
                                        </div> -->

                    <div class="form-group col-md-12">
                      <label for="avatar"></label>
                      <div class="row align-items-center">
                        <div class="col-4">
                          <div class="input-group">
                            <div class="custom-file">
                              <input type="file" name="avatar" class="custom-file-input" id="avatar" @change="selectFile"
                                accept="image/x-png,image/jpg,image/jpeg">
                              <label class="custom-file-label">Choose file</label>
                            </div>

                          </div>
                        </div>
                        <div class="col-8">
                          <img alt="preview image" v-if="accountInfo.avatar" v-bind:src="accountInfo.avatar" width="100"
                            height="100" class="img-circle" style="object-fit: cover;" />
                        </div>
                        <div class="help text-danger" v-show="errors.has('avatar')">
                          {{ errors.first('avatar') }}
                        </div>
                      </div>

                    </div>

                    <button type="submit" class="btn btn-dark-blue">Update Info</button>

                  </div>

                </div>
                <!-- <div class="card-footer">
                                      <div class="col-md-8">
                                      </div>
                                </div> -->
              </div>

            </div>

            <!-- <div class="col-md-6">
                    <div class="card">

                      <div class="card-header">
                        <div class="card-tools">
                            Address
                        </div>
                      </div>

                      <div class="card-body">
                          <div class="col-md-10">
                                <div class="form-group">
                                                <label for="streetAddress">Street Address</label>
                                                <textarea rows="3" cols="12" type="text" class="form-control" id="streetAddress"
                                                v-model="accountInfo.streetAddress"
                                                placeholder="Street Address" />
                                </div>
                                <div class="form-group">
                                    <label for="area">Area</label>
                                    <input type="text" class="form-control" id="area"
                                    v-model="accountInfo.area"
                                    placeholder="Area">
                                </div>
                                <div class="form-group">
                                    <label for="floorNo">Floor No</label>
                                    <input type="text" class="form-control" id="floorNo"
                                    v-model="accountInfo.floorNo"
                                    placeholder="Floor No">
                                </div>

                                <div class="form-group">
                                    <label for="apartmentNo">Apartment No</label>
                                    <input type="text" class="form-control" id="apartmentNo"
                                    v-model="accountInfo.apartmentNo"
                                    placeholder="Apartment No">
                                </div>
                          </div>
                       </div>


                        <div class="overlay" v-if="is_loading">
                          <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                        </div>
                        <div class="card-footer">
                            <button type="submit" class="btn btn-common m-2px">Update Info</button>
                        </div>
                    </div>
              </div> -->


          </div>

          <!-- <div class="row">
             <div class="col-md-4">
             </div>
            <div class="col-md-4">
                      <button class="btn btn-common m-2px">Update Info</button>
            </div>
            <div class="col-md-4">
            </div>
          </div> -->

        </form>
      </div>

    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<style scoped>
div.card-body label {
  font-weight: 12;
  display: inline-flex;
}

button.btn-common {
  width: 100%;
  display: inline-flex;
  justify-content: center;
  background-color: #3C206B !important;
}
</style>
<script>

import VuePagination from '@/components/partials/PaginationComponent'
import SortIcons from '@/components/utils/SortIcons'
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { CommonAPI } from '@/services/api'
import { Notification } from 'element-ui'
const fileDownload = require('js-file-download')

export default {
  name: 'DataUsage',
  metaInfo: {
    title: 'Account Info | Dotlines'
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons
  },

  data: () => ({


    accountInfo: {
      firstName: '',
      lastName: '',
      emailAddress: '',
      phone: '',

      streetAddress: '',
      avatar: null
      // area: '',
      // floorNo: '',
      // apartmentNo: ''
    },

    value: {
      // package: '10MB',
      // monthlyAmount: '2000TK',
      // availableBalance: '3000TK',
      // billDueDate: '10/02/2022'
    },

    paymentModel: {
      cuid: '',
      amount: 0,
      phone: '0190213',
      name: '',
      email: '',
      city: '',
      address: '',
      description: ''
    },

    list: {
      total: 0,
      per_page: 3,
      from: 1,
      to: 0
    },
    order_by: 'asc',
    api_url: '',
    showFilter: false,
    filter: {},
    dateRange: '',
    pre: [],
    is_loading: false,
    has_permission: true
  }),
  // method is called after page load
  mounted: function () {

    // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click')
    // }

    this.getAccountDetail();
    // this.getPackageInfo();
    // this.getMyAccountDetails();

    // this.api_url = '/admin_users';
    // this.getUsageData();
    // // this.getOrganization();
    // this.$root.$on('sort-data', () => {
    //   this.$root.$emit('show-icon');
    //   this.getUsageData();
    // });
  },
  methods: {

    selectFile: function (event) {
      // `files` is always an array because the file input may be in multiple mode
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0])
      reader.onload = () => {
        // this.is_avatar = true;
        this.accountInfo.avatar = reader.result;
      };
    },

    getAccountDetail: function () {
      let api_url = '/get-account-info';
      let _this = this;
      _this.is_loading = true;
      axios.get(api_url)
        .then(response => {
          console.log('response.data::', response.data);
          _this.accountInfo.firstName = response.data.firstName;
          _this.accountInfo.lastName = response.data.lastName;
          _this.accountInfo.emailAddress = response.data.email;
          _this.accountInfo.phone = response.data.phone;
          //_this.accountInfo.area = response.data.city;

          // let addressParts = response.data.address.split(',');
          // console.log("Address Parts::", addressParts);

          // _this.accountInfo.streetAddress = addressParts.length > 0 ? addressParts[0] : '';
          // _this.accountInfo.floorNo = addressParts.length > 1 ? addressParts[1] : '';
          // _this.accountInfo.apartmentNo = addressParts.length > 2 ? addressParts[2] : '';

          // _this.value = response.data;
          _this.is_loading = false;
        })
        .catch((error) => {
          console.log('error ' + error);
          _this.is_loading = false;
        });
    },

    getPackageInfo: function () {
      let api_url = '/get-bill-info';
      let _this = this;
      _this.is_loading = true;
      axios.get(api_url)
        .then(response => {
          console.log('response.data::', response.data);
          _this.value = response.data;
          _this.is_loading = false;
        })
        .catch((error) => {
          console.log('error ' + error);
          _this.is_loading = false;
        });
    },

    getMyAccountDetails() {
      let api_url = '/get-account-info';
      let _this = this;
      _this.is_loading = true;
      axios.get(api_url)
        .then(response => {
          console.log('response.data::', response.data);
          _this.paymentModel = response.data;
          _this.paymentModel.name = response.data.username;
          _this.paymentModel.city = response.data.city;
          // _this.value = response.data;
          _this.is_loading = false;
        })
        .catch((error) => {
          console.log('error ' + error);
          _this.is_loading = false;
        });
    },


    AccountInfoUpdate() {
      const _this = this
      console.log(_this.accountInfo)
      // return

      _this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          const api_url = '/account-info-update'
          const method = 'POST'
          console.log(this.paymentModel)
          axios({
            method: method,
            url: api_url,
            data: _this.accountInfo,
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function (response) {
              console.log(response.data)
              const responseData = response.data
              if (responseData && responseData.status === 200) {
                _this.$toaster.success(responseData.message)
              } else {
                _this.$toaster.success(responseData.message)
              }
              _this.is_loading = false
            })
            .catch((errors) => {
              _this.$setErrorsFromResponse(errors.response.data)
            })
            .finally(() => {
              _this.is_loading = false
            })
        } else {
          console.log('Validation failed')
        }
      })
    },

    RequestPayment() {
      const _this = this
      // window.open('https://demo-cashier.dotlines.com.bd/short/redirect.php?payment_id=Centc418833.68616149-19072-KfiNH', '_self');
      // window.url
      _this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          const api_url = '/request-payment'
          const method = 'POST'
          console.log(this.paymentModel)
          axios({
            method: method,
            url: api_url,
            data: _this.paymentModel,
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function (response) {
              console.log(response.data)
              const responseData = response.data
              if (responseData && responseData.status === '200') {
                var paymentId = responseData.data.payment_id
                paymentId = encodeURIComponent(paymentId)
                const redirectUrl = responseData.data.redirect_url + '?payment_id=' + paymentId
                window.open(redirectUrl, '_self')
              } else {
                _this.$toaster.success(responseData.message)
              }
              // alert('Success')
              // _this.$toaster.success(response.data.message)
              _this.is_loading = false
              // _this.$router.push({ name: "Users" });
            })
            .catch((errors) => {
              _this.$setErrorsFromResponse(errors.response.data)
            })
            .finally(() => {
              _this.is_loading = false
            })
        } else {
          console.log('Validation failed')
        }
      })
    },

    OpenTicket() {
      const _this = this
      _this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          const api_url = '/open-ticket'
          const method = 'POST'
          console.log(this.ticket)
          axios({
            method: method,
            url: api_url,
            data: _this.ticket,
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message)
              _this.is_loading = false
              // _this.$router.push({ name: "Users" });
            })
            .catch((errors) => {
              _this.$setErrorsFromResponse(errors.response.data)
            })
            .finally(() => {
              _this.is_loading = false
            })
        } else {
          console.log('Validation failed')
        }
      })
    },

    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD hh:mm:ss')
    },

    getUsageData() {
    },

    getUsers() {

    },

    apiUsage(query = null) {
      return new Promise((resolve, reject) => {
        axios.get(this.api_url, {
          params: query
        }).then(response => {
          resolve(response.data)
        }).catch(error => {
          if (error.response.status === 403) {
            this.has_permission = false
          }
          reject(error)
        })
      })
    }

  }
}
</script>
